export default __webpack_public_path__ + "static/media/delete_button.a7ae5be8.png";